import qs from 'query-string';
import { lStorage, lStorageKeys } from '../helpers/lStorage';
import { history } from '../helpers/history';
import {_url} from './../helpers/makeUrl';
import {getLocation} from './../helpers/getLocation'



export const catalogService = {
    getView,
    setView,
    getSort,
    setSort,
    getOnStock,
    setOnStock,
    generateUrl,
    getPage,
    setPage,
    setFilters,
    generateUrlForMenu
};

const viewDefault 		= 'big-tiles';
const sortDefault 		= '';
const onStockDefault 	= '';



function get(type, lStorageToken, defaultVal) {
	const query = getLocation.search
	if (query[type]) {
		return query[type]
	}
	let val = lStorage.get(lStorageToken)
    if (val) {
    	checkUrl(type, val, defaultVal)
    	return val
    }
    return defaultVal
}

function checkUrl(type, val, defaultVal, historyProps) {

    let his = typeof historyProps !== 'undefined' ? historyProps : history
	const query = getLocation.search
	//sprawdzamy czy parametr ustawiony w url jesli nie ustawiamy
    if (query && val != defaultVal && (!query[type] || query[type] != val)) {
    	query[type] = val
    	his.push({
        	search: qs.stringify(query)
    	})
    }
    //sprawdzamy czy to domyślny parametr jeśli tak możemy go wywalić
    if (val == defaultVal ) {
    	delete query[type]
    	his.push({
        	search: qs.stringify(query)
    	})
    }
}


function getPage() {
	const query = getLocation.search
	if (query.p) {
		return query.p
	}
	return 1
}

function setPage(page, history)
{
	return checkUrl('p', page, 1, history)
}


function getView() {
	return get('view', lStorageKeys.CATALOG_VIEW, viewDefault)
}


function setFilters(filters) {

    Object.keys(filters).forEach((key) => {
        let name = key == 'producers' ? 'producers' : 'p'+key
        let value = Array.isArray(filters[key]) ?  filters[key].join(',') : filters[key] ;
        checkUrl(name, value, '')
    });
    //return get('view', lStorageKeys.CATALOG_VIEW, viewDefault)
}

function setView(view) {
	lStorage.set(lStorageKeys.CATALOG_VIEW, view);
    //sprawdzamy czy mamy ustawione w url jeśli nie ustawiamy
    checkUrl('view', view, viewDefault)
}


function getSort() {
	return get('sort', lStorageKeys.CATALOG_SORT, sortDefault)
}



function setSort(sort) {
    lStorage.set(lStorageKeys.CATALOG_SORT, sort);
    //sprawdzamy czy mamy ustawione w url jeśli nie ustawiamy
    checkUrl('sort', sort, sortDefault)
}

function getOnStock() {
	return get('st', lStorageKeys.CATALOG_ON_STOCK, onStockDefault)
}



function setOnStock(stock) {
    lStorage.set(lStorageKeys.CATALOG_ON_STOCK, stock);
    //sprawdzamy czy mamy ustawione w url jeśli nie ustawiamy
    checkUrl('st', stock, onStockDefault)
}



function generateUrlForMenu(groupId, typeMenu, hash) {
    let menuInfo = typeMenu == 'by-cat' ? 'c' : 'p'
    let producerId = 0
    if (typeMenu == 'by-prod') {
        let prod = groupId.split(".")
        groupId = prod[1]
        producerId = prod[0]
    }
    menuInfo = menuInfo+hash
    return generateUrl(groupId, producerId, 1, 0, 0, 0, menuInfo)
}



function generateUrl(groupId, producerId, page, sort, view, onStock, menuInfo) {

	let url = _url("/catalog/"+groupId);
	let searchUrl = {}
	if (producerId && producerId>0) {
		searchUrl.producers = producerId
	}

	if (page && page > 1) {
		searchUrl.p = page
	}

	if ( sort != sortDefault) {
		searchUrl.sort = sort
	}

	if (view && view != viewDefault) {
		searchUrl.view = view
	}

	if (onStock != onStockDefault) {
		searchUrl.st = onStock
	}

    if (menuInfo) {
        searchUrl.mi = menuInfo
    }

	return url+(qs.stringify(searchUrl) ? '?'+qs.stringify(searchUrl) : '')
}